import { render, staticRenderFns } from "./RCovid.vue?vue&type=template&id=5f3b366a&scoped=true&"
import script from "./RCovid.vue?vue&type=script&lang=js&"
export * from "./RCovid.vue?vue&type=script&lang=js&"
import style0 from "./RCovid.vue?vue&type=style&index=0&id=5f3b366a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b366a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VSnackbar,VTextField})
